export namespace RendererErrorCatcher {
  export enum ErrorCodes {
    StateDesynchronisation = 'StateDesynchronisation',
  }

  export namespace Plugin {
    export const Name = 'rendererErrorCatcher';
  }
}
